<ng-container *ngIf="errors$ | async as errors">
  <p class="prose prose-text-xs mt-2 text-primary-600" *ngFor="let error of errors" translate>
    {{ error }}
  </p>
</ng-container>
